import * as React from 'react';

import { useComponent } from 'hooks';
import { ConfirmationDialog } from 'ui';

export const StateChangeConfirmModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  newState: string;
}> = useComponent(({ isOpen, onClose, onConfirm, newState }) => {
  return (
    <ConfirmationDialog
      handleClose={onClose}
      isOpen={isOpen}
      handlePrimaryAction={onConfirm}
      message={''}
      title={`This location was created with a different state. Are you sure you’d like to use ${newState}?`}
      actionText={`Yes, use ${newState}`}
      cancelAction
      iconType="alert"
    />
  );
});
